import { useEffect, useState } from 'react';

interface NavbarProps {
  mousePosition: { x: number; y: number };
}

export default function Navbar({ mousePosition }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [reflectionAngle, setReflectionAngle] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const angle = Math.atan2(mousePosition.y - 50, mousePosition.x - window.innerWidth / 2);
    setReflectionAngle(angle * (180 / Math.PI));
  }, [mousePosition]);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-6 left-1/2 -translate-x-1/2 z-50 transition-all duration-500 ${
        scrolled ? 'w-[95%] max-w-6xl' : 'w-[90%] max-w-5xl'
      }`}
    >
      <div
        className="relative backdrop-blur-xl bg-white/40 border border-white/60 rounded-2xl shadow-lg px-8 py-4 transition-all duration-300"
        style={{
          background: `linear-gradient(${reflectionAngle}deg, rgba(255,255,255,0.45) 0%, rgba(255,255,255,0.35) 100%)`,
        }}
      >
        <div className="flex items-center justify-between">
          <button
            onClick={() => scrollToSection('hero')}
            className="text-xl font-semibold text-black tracking-tight whitespace-nowrap cursor-pointer"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Arafat Studio
          </button>

          <div className="flex items-center gap-10">
            {['Work', 'About', 'Process', 'Contact'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item.toLowerCase())}
                className="text-sm font-medium text-black/80 hover:text-black transition-colors duration-300 whitespace-nowrap cursor-pointer"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}
